export default __webpack_public_path__ + "static/media/polygon.f4bb6f60.svg";